import { ListIcon, XIcon } from "@phosphor-icons/react";
import { Button, Sheet, SheetClose, SheetContent, SheetTrigger } from "@reactive-resume/ui";
import { useState } from "react";
import { Link } from "react-router";

import { Icon } from "@/client/components/icon";
import { NotificationCenter } from "@/client/services/notification";
import { UserAvatar } from "@/client/components/user-avatar";
import { UserOptions } from "@/client/components/user-options";

import { Sidebar } from "./sidebar";

type AdminHeaderProps = {
  className?: string;
};

export const AdminHeader = ({ className }: AdminHeaderProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`sticky top-0 z-30 flex items-center justify-between border-b border-admin-border bg-admin-surface p-4 pb-0 ${className || ""}`}
    >
      <div className="flex items-center gap-3">
        {/* Bouton Menu Mobile */}
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <Button
              size="icon"
              variant="ghost"
              className="bg-transparent text-admin-text-primary hover:bg-admin-surface-hover lg:hidden"
            >
              <ListIcon size={32} weight="light" />
            </Button>
          </SheetTrigger>

          <SheetContent
            showClose={false}
            side="left"
            className="border-r border-admin-border bg-admin-surface p-0 focus-visible:outline-none"
          >
            <SheetClose asChild className="absolute left-4 top-4 z-10">
              <Button
                size="icon"
                variant="ghost"
                className="bg-transparent text-admin-text-primary hover:bg-admin-surface-hover"
              >
                <XIcon size={32} weight="thin" />
              </Button>
            </SheetClose>

            <Sidebar setOpen={setOpen} />
          </SheetContent>
        </Sheet>

        {/* Logo / Lien Accueil */}
        <Button
          asChild
          size="icon"
          variant="ghost"
          className="bg-transparent text-admin-text-primary hover:bg-admin-surface-hover"
        >
          <Link to="/">
            <Icon size={32} />
          </Link>
        </Button>
      </div>

      <div className="flex items-center gap-3 py-2">
        <NotificationCenter align="end" allNotificationsHref="/admin/dashboard/overview" />
        <UserOptions>
          <Button
            size="sm"
            variant="ghost"
            className="bg-transparent text-admin-text-primary hover:bg-admin-surface-hover"
          >
            <UserAvatar size={32} className="mr-2" />
          </Button>
        </UserOptions>
      </div>
    </div>
  );
};
